import { motion } from "framer-motion";

import type { RefObject } from "react";

import { useMountEffect } from "../hooks/useMountEffect";
import type { CameraStatus } from "../model/types";

type SmileSimulationLiveCameraProps = {
  fallbackMessage: string;
  message: string;
  onStartCamera: () => Promise<void>;
  onStopCamera: () => void;
  shouldMirror: boolean;
  status: CameraStatus;
  videoRef: RefObject<HTMLVideoElement | null>;
};

export function SmileSimulationLiveCamera({
  fallbackMessage,
  message,
  onStartCamera,
  onStopCamera,
  shouldMirror,
  status,
  videoRef,
}: SmileSimulationLiveCameraProps) {
  useMountEffect(() => {
    void onStartCamera();

    return () => {
      onStopCamera();
    };
  });

  return (
    <>
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        className="h-full w-full object-cover"
        style={{ transform: shouldMirror ? "scaleX(-1)" : undefined }}
      />
      {status !== "ready" && (
        <div className="bg-[#13071f]/82 absolute inset-0 flex flex-col items-center justify-center gap-3 px-8 text-center text-white">
          {status === "requesting" && (
            <motion.div
              className="h-10 w-10 rounded-full border-2 border-white/25 border-t-white"
              animate={{ rotate: 360 }}
              transition={{
                duration: 1,
                repeat: Infinity,
                ease: "linear",
              }}
            />
          )}
          <p className="text-sm font-medium">{message || fallbackMessage}</p>
        </div>
      )}
    </>
  );
}
